module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_construction-b205af19ebbda96c418b735e70ff6f7d.svg";